import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-3",
  id: "inline-usage"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#inline-usage" }),
  /*#__PURE__*/_createTextVNode(" Inline Usage ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Use svg icons as inline svg element in order to customize the icon size and color via CSS: ", -1)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = { class: "rounded border d-flex flex-wrap p-10" }
const _hoisted_6 = { class: "svg-icon svg-icon-3x me-10" }
const _hoisted_7 = { class: "svg-icon svg-icon-3x me-10" }
const _hoisted_8 = { class: "svg-icon svg-icon-3x me-10" }
const _hoisted_9 = { class: "svg-icon svg-icon-3x me-10" }
const _hoisted_10 = { class: "svg-icon svg-icon-3x me-10" }
const _hoisted_11 = { class: "svg-icon svg-icon-3x me-10" }
const _hoisted_12 = { class: "svg-icon svg-icon-3x me-10" }
const _hoisted_13 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("span", _hoisted_6, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Design/Adjust.svg" })
        ]),
        _createVNode("span", _hoisted_7, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Git3.svg" })
        ]),
        _createVNode("span", _hoisted_8, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Communication/Chat2.svg" })
        ]),
        _createVNode("span", _hoisted_9, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Files/File-plus.svg" })
        ]),
        _createVNode("span", _hoisted_10, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/Settings-2.svg" })
        ]),
        _createVNode("span", _hoisted_11, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Tools/Tools.svg" })
        ]),
        _createVNode("span", _hoisted_12, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Chart-bar3.svg" })
        ])
      ])
    ]),
    _createVNode("div", _hoisted_13, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`<!--begin::Svg Icon | path: '.svg/icons/Design/Adjust.svg.'-->
        <span class="svg-icon svg-icon-3x"
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            version="1.1"
          >
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <rect x="0" y="0" width="24" height="24" />
              <path
                d="M12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 C16.418278,4 20,7.581722 20,12 C20,16.418278 16.418278,20 12,20 Z M12,5.99999664 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18.0000034 L12,5.99999664 Z"
                fill="#000000"
                fill-rule="nonzero"
              />
            </g></svg
        ></span>
        <!--end::Svg Icon-->`), 1)
        ]),
        _: 1
      })
    ])
  ]))
}